//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// imports
import Vue from 'vue';
import * as PIXI from 'pixi.js-legacy';

// Animation Manager class to keep track of all ticker functions
class AnimationManager {
    constructor (ticker) {
        ticker.maxFPS = 15;

        this.ticker = ticker;
        this.functions = [];
    }

    add (func) {
        this.ticker.add(func);
        this.functions.push(func);
    }

    remove (func) {
        this.ticker.remove(func);
    }

    cleanup () {
        this.functions.forEach(func => this.ticker.remove(func));
        this.functions = [];
    }
}

// Loadermanager to manage resource loading and draw function calling.
class LoaderManager {
    constructor (loader) {
        this.loader = loader;
        this.loading = false;
        this.functions = [];
        this.queue = [];
        this.debouncedLoad = _.debounce(this.load.bind(this));

        this.loader.onComplete.add(() => {
            this.functions.forEach(item => {
                if (!item.component._isDestroyed) {
                    item.func();
                }
            });

            this.cleanup();
            this.workQueue();
        });
    }

    workQueue () {
        this.queue.forEach(({ component, func, imagePath }) => {
            this.addToLoader(component, func, imagePath);
        });

        this.queue = [];
    }

    add (component, func, imagePath = '') {
        if (this.loading) {
            this.queue.push({
                component,
                func,
                imagePath
            });
            return;
        }

        this.addToLoader(component, func, imagePath);
    }

    addToLoader (component, func, imagePath) {
        this.functions.push({
            component,
            func
        });

        if (imagePath !== '' && this.loader.resources[imagePath] === undefined) {
            this.loader.add(imagePath);
        }

        this.debouncedLoad();
    }

    load () {
        this.loading = true;
        this.loader.load();
    }

    cleanup () {
        this.functions = [];
        this.loader.reset();
        PIXI.utils.clearTextureCache();
        this.loading = false;
    }
}

export default {
    data () {
        return {
            ready: false,
            EventBus: new Vue(),
            PIXIWrapper: {
                PIXI: PIXI,
                app: null,
                AnimationManager: null,
                sizes: {
                    gameWidth: 1200,
                    gameHeight: 816,
                    canvasWidth: 0,
                    canvasHeight: 0,
                    scaleFactorX: 1,
                    scaleFactorY: 1
                }
            }
        };
    },

    provide () {
        return {
            PIXIWrapper: this.PIXIWrapper,
            EventBus: this.EventBus
        };
    },

    created () {
        this.create();

        window.onresize = event => {
            if (document.getElementsByTagName('video').length) {
                return;
            }

            if (document.activeElement.nodeName === 'INPUT' && document.activeElement.type === 'text') {
                return;
            }

            this.resize();
        };
    },

    destroyed () {
        this.PIXIWrapper.AnimationManager.cleanup();
        this.PIXIWrapper.LoaderManager.cleanup();
        this.PIXIWrapper.app.destroy(true, true);
    },

    methods: {
        create () {
            this.setSizes();

            this.$nextTick(() => {
                // create pixi app
                this.PIXIWrapper.app = new PIXI.Application({
                    view: this.$refs.canvas,
                    resizeTo: this.$refs.canvasWrapper,
                    backgroundColor: 0x270F27,
                    antialias: true
                });

                // create animation manager
                this.PIXIWrapper.AnimationManager = new AnimationManager(this.PIXIWrapper.app.ticker);

                // create loader manager
                this.PIXIWrapper.LoaderManager = new LoaderManager(this.PIXIWrapper.app.loader);

                // load open sans font
                let font = new FontFaceObserver('Open Sans');

                font.load().then(() => {
                    this.ready = true;
                }).catch(() => {
                    console.log('Could not load Open Sans font.');
                });
            });
        },
        resize: _.debounce(function () {
            this.ready = false;
            this.PIXIWrapper.AnimationManager.cleanup();
            this.setSizes();

            this.$nextTick(() => {
                this.PIXIWrapper.app.resize();
                this.ready = true;
            });
        }, 1000),
        setSizes () {
            let aspectRatioWidth = window.innerHeight * (this.PIXIWrapper.sizes.gameWidth / this.PIXIWrapper.sizes.gameHeight);
            let aspectRatioHeight = window.innerWidth * (this.PIXIWrapper.sizes.gameHeight / this.PIXIWrapper.sizes.gameWidth);

            this.PIXIWrapper.sizes.canvasWidth = (aspectRatioHeight > window.innerHeight) ? aspectRatioWidth : window.innerWidth;
            this.PIXIWrapper.sizes.canvasHeight = (aspectRatioHeight > window.innerHeight) ? window.innerHeight : aspectRatioHeight;

            this.PIXIWrapper.sizes.canvasWidth = (this.PIXIWrapper.sizes.canvasWidth > this.PIXIWrapper.sizes.gameWidth) ? this.PIXIWrapper.sizes.gameWidth : this.PIXIWrapper.sizes.canvasWidth;
            this.PIXIWrapper.sizes.canvasHeight = (this.PIXIWrapper.sizes.canvasHeight > this.PIXIWrapper.sizes.gameHeight) ? this.PIXIWrapper.sizes.gameHeight : this.PIXIWrapper.sizes.canvasHeight;

            if (this.PIXIWrapper.sizes.canvasWidth > window.innerWidth) {
                this.PIXIWrapper.sizes.canvasWidth = window.innerWidth;
                this.PIXIWrapper.sizes.canvasHeight = aspectRatioHeight;
            }

            this.PIXIWrapper.sizes.scaleFactorX = this.PIXIWrapper.sizes.canvasWidth / this.PIXIWrapper.sizes.gameWidth;
            this.PIXIWrapper.sizes.scaleFactorY = this.PIXIWrapper.sizes.canvasHeight / this.PIXIWrapper.sizes.gameHeight;
        }
    }
};
